(function () {
  if (window.customElements && customElements.get('frm-tour-timeline')) return;

  class FrmTourTimeline extends HTMLElement {
    connectedCallback() {
      this.nodes = Array.from(this.querySelectorAll('.frm-tour-timeline__stop'));
      this.bike = this.querySelector('.frm-tour-timeline__bike');
      this.line = this.querySelector('.frm-tour-timeline__line');
      this.progress = 0;
      this.update();

      this.onResize = () => this.positionBike(this.progress);
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    positionBike(progress) {
      if (!this.bike || !this.line) return;
      const lineRect = this.line.getBoundingClientRect();
      const containerRect = this.bike.offsetParent.getBoundingClientRect();
      this.bike.style.left = lineRect.left - containerRect.left + progress * lineRect.width + 'px';
    }

    update() {
      const now = new Date();
      const lastIndex = this.nodes.length - 1;
      const dated = this.nodes
        .map((node, index) => ({ node, index, date: node.dataset.date ? new Date(node.dataset.date) : null }))
        .filter((entry) => entry.date instanceof Date && !isNaN(entry.date));

      if (!dated.length || lastIndex < 1) return;

      let progress = 0;
      let reachedIndex = 0;

      if (now <= dated[0].date) {
        progress = 0;
        reachedIndex = 0;
      } else if (now >= dated[dated.length - 1].date) {
        progress = 1;
        reachedIndex = lastIndex;
      } else {
        for (let i = 0; i < dated.length - 1; i++) {
          const current = dated[i];
          const next = dated[i + 1];
          if (now >= current.date && now <= next.date) {
            const span = next.date - current.date;
            const fraction = span > 0 ? (now - current.date) / span : 0;
            progress = (current.index + (next.index - current.index) * fraction) / lastIndex;
            reachedIndex = current.index;
            break;
          }
        }
      }

      this.progress = progress;
      this.style.setProperty('--frm-tour-timeline-progress', progress);
      this.positionBike(progress);

      this.nodes.forEach((node, index) => {
        const isReached = index === reachedIndex;
        node.classList.toggle('is-passed', index <= reachedIndex || progress >= 1);

        if (index === 0 || index === lastIndex) return;

        node.removeAttribute('aria-current');
        const flag = node.querySelector('.frm-tour-timeline__current-flag');
        if (flag) flag.hidden = !isReached;
        if (isReached) node.setAttribute('aria-current', 'step');
      });

      if (this.bike) this.bike.hidden = progress >= 1;
    }
  }

  customElements.define('frm-tour-timeline', FrmTourTimeline);
})();
